module.exports = __webpack_public_path__ + "img/book-btn01.76e36f3e.png";